import { cn, Kbd, StatusBadge } from "@nexxt/ui";
import { m } from "../../paraglide/messages.js";
import { vars } from "../css-vars";
import { useSceneTimeline } from "../motion/use-scene-timeline";
import { AppWindow } from "./app-window";

// Backstage at work (ADR-286): the home counts, ⌘K finds the purchase order, the panel approves it, the count drops.
const durations = [2000, 2200, 2400, 2800] as const;
const places = ["Home", "Linesheets", "Purchase orders", "Sales orders", "Directory"];
const searched = "PO-4512";

export function BackstageScene({ active, still, dark }: { active: boolean; still: boolean; dark: boolean }) {
  const step = useSceneTimeline(durations, active, still);
  const approved = step === 3;
  return (
    <AppWindow app="backstage" dark={dark} title="backstage.nexxt" places={places} className={`is-step-${step}`}>
      <div className="scene-pad">
        <p className="scene-heading">{m.scene_backstage_home()}</p>
        <div className="queue-cards">
          <QueueCard count={approved ? 2 : 3} label={m.scene_backstage_queue_po()} flash={approved} />
          <QueueCard count={5} label={m.scene_backstage_queue_proposals()} />
          <QueueCard count={2} label={m.scene_backstage_queue_credit()} />
        </div>
      </div>
      <div className={cn("palette", step === 1 && "is-open")}>
        <div className="palette-input">
          <Kbd>⌘K</Kbd>
          {step === 1 ? (
            <span className="typing font-mono" style={vars({ "--chars": searched.length })}>
              {searched}
            </span>
          ) : (
            <span className="text-muted-foreground">{m.scene_backstage_search()}</span>
          )}
        </div>
        <div className="palette-result">
          <span className="font-mono">{searched}</span>
          <span className="text-muted-foreground">Maglificio Aurora</span>
        </div>
      </div>
      <div className={cn("side-panel", step >= 2 && "is-open")}>
        <p className="font-mono text-xs text-muted-foreground">{searched}</p>
        <p className="font-medium">Maglificio Aurora</p>
        <p className="text-muted-foreground text-xs">{m.scene_backstage_lines({ count: 4 })} · € 48,300.00</p>
        {approved ? (
          <StatusBadge tone="success" label={m.scene_backstage_approved()} />
        ) : (
          <StatusBadge tone="warning" label={m.scene_backstage_awaiting()} />
        )}
        {!approved && (
          <span className={cn("mock-button", step === 2 && "is-pressing")}>{m.scene_backstage_approve()}</span>
        )}
      </div>
    </AppWindow>
  );
}

function QueueCard({ count, label, flash = false }: { count: number; label: string; flash?: boolean }) {
  return (
    <div className={cn("queue-card", flash && "is-flash")}>
      <strong className="tabular-nums">{count}</strong>
      <span>{label}</span>
    </div>
  );
}
